import router from './index'
import store from '../vuex/store'
import Loading from 'quasar/src/plugins/Loading.js';

let requestsTotal = 0
let requestsCompleted = 0
const latencyThreshold = 100
const responseLatency = 50

const setComplete = () => {
  requestsTotal = 0
  requestsCompleted = 0
  Loading.hide()
}

const interceptor = (request, next) => {
  if (!request.url.includes('webmaniabr')) {
    if (!store.getters.getEmpresa.token && store.getters.getUsuario.token) {
      request.headers.set('Authorization', `Bearer: ${store.getters.getUsuario.token}`)
    } else if (store.getters.getEmpresa.token) {
      request.headers.set('Authorization', `Bearer: ${store.getters.getEmpresa.token}`)
    }
  }

  if (requestsTotal === 0) {
    if (latencyThreshold === 0) {
      Loading.show()
    } else {
      setTimeout(() => {
        if (requestsTotal !== requestsCompleted) {
          Loading.show()
        }
      }, latencyThreshold)
    }
  }
  requestsTotal++

  next((response) => {
    if (response.status === 0 || response.status === null) {
      response.status = 400
      response.statusText = 'Bad Request'
      if (!response.body) {
        response.body = {
          message: 'Erro ao conectar ao serviço de back-end. \nProcure o suporte!'
        }
      }
    } else {
      if (response.status >= 400 && !response.body) {
        response.body = {
          message: 'Requisição não concluída. \nProcure o suporte!'
        }
      }
    }

    setTimeout(() => {
      requestsCompleted++

      if (requestsCompleted >= requestsTotal) {
        setComplete()
      }
    }, responseLatency)

    if (response.status === 403 || response.status === 401) {
      store.dispatch('setUsuario', null)
      store.dispatch('setEmpresa', null)
      store.dispatch('setEmpresaLogo', null)
      router.push({ path: '/login' })
    }
    return response
  })
}

export default interceptor
